import { env } from '@/constants/env';

export const getLogoImageUrl = (logoId: string): string =>
  `${env.API_URL}/images/${encodeURIComponent(logoId)}`;
